export const RoutesReportsObject = [
  {
    regex: /^\/itineraries\/reports\/?$/,
    title: 'Relatórios',
  },
]

export const RoutesReportsComponents = [

]
